import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { TenStatistics } from './TenDashboardStatistics';

interface ReportData {
  reportData?: any;
  filters?: {
    selectedFormat: string;
    selectedProgramme: string;
    selectedSupporters: string[];
    selectedComparison: string;
  };
}

const TenDashboardResultsMain: React.FC = () => {
  const location = useLocation();
  const [reportData, setReportData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState<any>(null);

  useEffect(() => {
    if (location.state) {
      const { reportData: data, filters: filterData } = location.state as ReportData;
      setReportData(data);
      setFilters(filterData);
    }
    setLoading(false);
  }, [location.state]);

  if (loading) {
    return (
      <div className='container-fluid mt-4 text-center py-5'>
        <div className="spinner-grow text-warning" role="status"></div>
        <p className="mt-2 text-muted">Loading report data...</p>
      </div>
    );
  }

  return <TenStatistics reportData={reportData} filters={filters} />;
};

export { TenDashboardResultsMain };
